import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c9cffce6")

_pushScopeId("data-v-c9cffce6")
const _hoisted_1 = { class: "display-inline" }
const _hoisted_2 = { class: "total-price" }
const _hoisted_3 = { class: "save" }
const _hoisted_4 = { class: "padding5px" }
const _hoisted_5 = { class: "description" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("b", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
      _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$wordList.ProperAllTextSave) + " $" + _toDisplayString(Math.round(_ctx.saveFee * 100 * _ctx.month) / 100), 1)
    ]),
    _createVNode(_component_el_popover, {
      placement: "top",
      width: 200,
      trigger: "hover"
    }, {
      reference: _withId(() => [
        _createVNode("b", _hoisted_5, _toDisplayString(_ctx.$wordList.ProperAllTextOfferDescription), 1)
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activity, (item) => {
            return (_openBlock(), _createBlock("p", { key: item }, [
              _createVNode("img", {
                class: "gift",
                src: require('@/assets/image/gift.png')
              }, null, 8, ["src"]),
              _createTextVNode(" " + _toDisplayString(item), 1)
            ]))
          }), 128))
        ])
      ]),
      _: 1
    })
  ]))
})